<template>
  <el-form label-width="110px">
    <div class="m-b-10">功能集布局配置</div>
    <el-form-item label="展示方式">
      <el-radio-group v-model="form.show_type">
        <el-radio :label="10">一般</el-radio>
        <el-radio :label="20">Tab</el-radio>
      </el-radio-group>
    </el-form-item>
    <div class="m-b-10 bor-b-ccc" v-for="(item, index) in form.arr">
      <el-form-item label="一级功能集">
        <el-select v-model="item.content_id">
          <el-option v-for="option in contents" :label="option.name" :value="option.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="绑定权限规则">
        <el-input v-model.trim="item.rule_name" class="h-40 fl w-150 m-r-10" :disabled="true" placeholder="绑定权限规则"></el-input>
        <el-button size="small" class="fl" @click="openRule(item)">查找</el-button>
        <el-button size="small" class="fl m-l-5" @click="clearRule(item)">清空</el-button>
      </el-form-item>
      <el-form-item v-if="form.show_type == 20 && form.arr.length > 1">
        <el-button size="small" type="primary" @click="sortUp(index)" :disabled="index == 0">上移</el-button>
        <el-button size="small" type="primary"  @click="sortDown(index)" :disabled="index == form.arr.length - 1">下移</el-button>
        <el-button size="small" @click="deleteContent(index)">删除</el-button>
      </el-form-item>
    </div>
    <el-form-item>
      <el-button type="primary" @click="addContent" v-if="form.show_type == 20">添加一个</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    props: {
      form: {
        type: Object,
        default() {
          return {}
        }
      },
      contents: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        contentModel: {
          content_id: '',
          rule_id: null,
          rule_name: ''
        },
        itemChange: false
      }
    },
    methods: {
      openRule(item) {
        this.$emit('openRule', item)
      },
      clearRule(item) {
        item.rule_name = ''
        item.rule_id = null
      },
      addContent() {
        this.form.arr.push(_.cloneDeep(this.contentModel))
      },
      deleteContent(index) {
        this.form.arr.splice(index, 1)
      },
      sortUp(index) {
        let temp = this.form.arr[index]
        this.form.arr.splice(index, 1)
        this.form.arr.splice(index - 1, 0, temp)
      },
      sortDown(index) {
        let temp = this.form.arr[index]
        this.form.arr.splice(index, 1)
        this.form.arr.splice(index + 1, 0, temp)
      }
    },
    watch: {
      'form'() {
        this.itemChange = true
        setTimeout(() => {
          this.itemChange = false
        }, 100)
      },
      'form.show_type'() {
        if (this.itemChange) {
          return
        }
        if (this.form.show_type == 10) {  // 展示方式为一般
          this.form.arr = []
          this.addContent()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// contentForm.vue?6d43709b